module.exports = __webpack_public_path__ + "static/media/logout_dropdown.f2052d47.svg";